import { first, type SqlDriver } from './db/driver';

/** Small device-local key/value settings (language, device identity, ...). */
export async function getMeta(db: SqlDriver, key: string): Promise<string | undefined> {
  return (await first<{ value: string }>(db, 'SELECT value FROM app_meta WHERE key = ?', [key]))?.value;
}

export async function setMeta(db: SqlDriver, key: string, value: string): Promise<void> {
  await db.run(
    'INSERT INTO app_meta (key, value) VALUES (?, ?) ON CONFLICT(key) DO UPDATE SET value = excluded.value',
    [key, value],
  );
}
